import { Link } from "react-router-dom";
import AuthPage from "../../components/layout/authPage";
import { Col, HeroBanner, IconArea, IconAreaImg, List, ListItem, Row, SubTitle, Text, Title, VImage } from "../../style/base.style";
import { circDouble, circleBg, clockIcon, doctorBanner2, doctorBanner3, doctorIcon, faq_img, faq_img2, hexagenBg, nurse, nurseImg, nurseImg2, phoneIcon, smiling_icon, stepsBg } from "../../constants/images";
import { useDictionary } from "../../contexts/dictionary";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Colors } from "../../style/colors";
import { FAQComponent } from "../../components/faq";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { QuickSignup } from "../../components/quickSignup";
import { useDeviceType } from "../../contexts/DeviceContext";
import { Hero } from "../../components/common/hero";

const faqData = [
  { 
    "question": "question_1_services", 
    "answer": "answer_1_services" 
  },
  { 
    "question": "question_2_payment", 
    "answer": "answer_2_payment" 
  },
  { 
    "question": "question_3_reimbursement", 
    "answer": "answer_3_reimbursement" 
  },
  { 
    "question": "question_4_hospice", 
    "answer": "answer_4_hospice" 
  },
  { 
    "question": "question_5_iv_treatment", 
    "answer": "answer_5_iv_treatment" 
  },
  { 
    "question": "question_6_viral_infections", 
    "answer": "answer_6_viral_infections" 
  }
]

const whyNurseHomeVisit =  [
  'post_surgery_patients','chronic_illness_patients','elderly_patients_nursing','anyone_needing_nursing_care'
]

const whenNurse =  [
  "when_to_order_nurse1",
  "when_to_order_nurse2",
  "when_to_order_nurse3",
  "when_to_order_nurse4"
]


export const HomeNursePage = () => {
    const {translate} = useDictionary();
    const {isMobile} = useDeviceType()
    AOS.init();
      useEffect(() => {
        AOS.init({
          duration: 1000,
        });
      }, []);
      const handleScroll = () => {
        AOS.refresh();
      };
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);

    const howItWorksSteps = [
      {
        title: translate("call_us"),
        img: phoneIcon,
      },
      {
        title: translate("nurse_home_visit_team_check"),
        img: clockIcon,
      },
      {
        title: translate("nurse_arrives"),
        img: doctorIcon,
      },
    
    ]
    return (
        <AuthPage>
            <Hero backgroundImage={circDouble} backgroundColor={Colors.lightBackground} heroImg={nurse}>
              <Title $color={Colors.primary} $fontSize={36} $margin="0 0 0 0">{translate("private_nurse")}</Title>
              <Title  $fontSize={36}$margin="0 0 20px 0">{translate("get_professional_nursing_care")}</Title>
            
            </Hero>
          {/* <HeroBanner $backgroundImage={doctorBanner3} className="aaaatest" $padding={`${isMobile?0:95}px 0 0 0`}  $alignItems={isMobile?"center":"flex-end"}>
        

          <Row  $height="100%" className="rowww">
            <Col $width={isMobile?'100%':'50%'} $alignItems="flex-start" >
            <Title $color={Colors.primary} $fontSize={36} $margin="0 0 0 0">{translate("private_nurse")}</Title>
            <Title  $fontSize={36}$margin="0 0 20px 0">{translate("get_professional_nursing_care")}</Title>
            
            </Col>
            {
              !isMobile &&
              <Col $width="25%" >
              <VImage src={nurse}  alt="doctor" />
            </Col>
            }
           {
              isMobile &&
              <Col $position="absolute"  $zIndex={-1}  $width="100%" $height="100%" className="doctor-images">
                <VImage src={nurse} $opacity={0.15}  alt="doctor" />
            </Col>
            }


            
          </Row>

          </HeroBanner> */}

          <HeroBanner $backgroundImage={circleBg} $background={Colors.primary} $padding="35px 0 0 0">
          <Row>
            <Col $width="100%" >
            <Title $color={Colors.whiteBackground} $fontSize={36} $margin="0 0 0 0">{translate("how_does_it_work")}</Title>
            <Row $margin="50px 0" $gap={20}>
              {howItWorksSteps.map((step, index) => {
                return (
                  <Col $border={`3px solid ${Colors.secondary}`} $borderRadius={5}  $color="#fff" $width="250px" $height="150px" key={index} $padding="30px 10px 0 10px" $margin="20px 0">
                  {step.title}
                  <IconArea $backgroundColor={Colors.secondary} top={-35} >
                    <IconAreaImg src={step.img}  alt="doctor"  $width={"60%"}/>
                  </IconArea>

                  </Col>
                )
              })}
            </Row>
            </Col>
            
          </Row>

          </HeroBanner>

             <section className="faq-section">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div  data-aos="fade-up">
                          <Col>
                          <Title $color={Colors.blackText} $fontSize={36} $margin="35px 0 0 0">{translate('faq_title')}</Title>
                          </Col>
                          
                          
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-lg-6 col-md-12 aos" data-aos="fade-up">
                        <div className="faq-img">
                          <VImage
                          $borderRadius="10px"
                          $width="80%"
                            src={faq_img2}
                            className="img-fluid"
                            alt="img"
                          />
                          
                        </div>
                        
                      </div>
                      <div className="col-lg-6 col-md-12 aos" data-aos="fade-up">
                      <FAQComponent numberOfQuestions={6} qa={faqData}/>
                      </div>
                          
                    </div>
                  </div>
                </section>


          <HeroBanner $backgroundImage={stepsBg} $background={Colors.primary} $padding="35px 0">
          <Row $width={isMobile?"100%":"60%"} $padding="15px" $alignItems="center" >
            <Col >
            <Title $color={Colors.whiteBackground} $fontSize={36} $margin="0 0 20px 0">{translate("nurse_home_visit")}</Title>
            <Text $color={Colors.whiteBackground} $fontSize={'20px'}>{translate("nurse_home_visit_desc")}</Text>
            <Col  $alignItems="flex-start" $justifyContent="flex-start" $padding="20px 0" $width="100%">
            <List>
              {
                whyNurseHomeVisit.map((item, index) => {
                  return (
                    <ListItem $color={Colors.whiteBackground} $fontSize={20} key={index}>{translate(item)}</ListItem>
                  )
                })
              }
            </List>
            </Col>
            </Col>
          </Row>

          </HeroBanner>

          <HeroBanner $backgroundImage={hexagenBg} $background={Colors.lightPrimary} $padding="35px 0">
          <Row $width={isMobile?"100%":"60%"}  $padding="15px">
            <Col>
            <Title $color={Colors.primary} $fontSize={36} $margin="0 0 20px 0">{translate("when_to_order_nurse")}</Title>
            <Col $alignItems="flex-start" $justifyContent="flex-start" $padding="20px 0">
            <List>
              {
                whenNurse.map((item, index) => {
                  return (
                    <ListItem $color={Colors.blackText} $fontSize={20} key={index}>{translate(item)}</ListItem>
                  )
                })
              }
              
            </List>
            </Col>

            
            
            </Col>
            
          </Row>

          </HeroBanner>

          <QuickSignup description="membership_title_nurses" benefits={["membership_priority_service","membership_quick_access_nurses","membership_signup_nurses"]}/>

  
          
          
        </AuthPage>
    );

}